import type { StatusLevel } from '@/hooks/useChinWorkspacePersistence';

// ─── Shared types for Chin Monitor ──────────────────────────

export interface CtraderAccount {
  id: number;
  account_id: string;
  account_name: string;
}

export interface SymbolEntry {
  symbolId: number;
  symbolName: string;
  digits: number;
  pipPosition?: number | null;
}

export interface SymbolList {
  id: string;
  name: string;
  ctrader_account_id: string | null;
  symbols: SymbolEntry[];
}

// ─── Constants ──────────────────────────────────────────────

export const STATUS_OPTIONS: { value: StatusLevel; label: string; shortLabel: string }[] = [
  { value: 'null', label: '—', shortLabel: '—' },
  { value: 'box_vs_candle', label: 'Box vs Nến', shortLabel: 'Box vs Nến' },
  { value: 'tma50_candle', label: 'TMA50 + Nến xu hướng, nến định hướng', shortLabel: 'TMA50 + Nến' },
  { value: 'ma_perfect', label: 'MA hoàn hảo + Nến định hướng, nến bẻ gãy, nến xu hướng, V ngã', shortLabel: 'MA hoàn hảo' },
  { value: 'ma_small', label: 'Tập hợp MA nhỏ', shortLabel: 'Tập hợp MA nhỏ' },
  { value: 'ma_large', label: 'Tập hợp MA lớn + Nến định hướng, nến xu hướng', shortLabel: 'Tập hợp MA lớn' },
  { value: 'candle_trend', label: 'Nến xu hướng', shortLabel: 'Nến xu hướng' },
];

export const CHIN_TIMEFRAME = 'H1';

// ─── Helpers ────────────────────────────────────────────────

export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}